module.exports = __webpack_public_path__ + "img/flag_and_logo.d295bb47.png";